import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { HelpCircle, ChevronDown, ChevronUp } from 'lucide-react';
import { useI18n } from '../i18n/I18nContext';
import { BackToHome } from '../components/BackToHome';
import { LanguageSwitcher } from '../components/LanguageSwitcher';
import { Tx } from '../components/EditMode';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const FAQPage = () => {
  const { t, lang } = useI18n();
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    axios.get(`${API}/faqs`)
      .then(r => setFaqs(r.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const q = (item) => (lang === 'no' && item.question_no) ? item.question_no : item.question_en;
  const a = (item) => (lang === 'no' && item.answer_no) ? item.answer_no : item.answer_en;

  return (
    <div data-testid="faq-page" className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100">
      <LanguageSwitcher variant="floating" />
      <BackToHome />
      <div className="max-w-3xl mx-auto px-4 py-16 sm:py-24">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-2.5 rounded-2xl bg-amber-100">
            <HelpCircle className="w-6 h-6 text-amber-700" />
          </div>
          <span className="text-xs font-bold text-amber-700 uppercase tracking-wider">FAQ</span>
        </div>
        <h1 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4 font-['Outfit'] tracking-tight">
          <Tx k="faq.title" />
        </h1>
        <p className="text-slate-600 mb-10 font-['Manrope'] leading-relaxed max-w-2xl">
          <Tx k="faq.subtitle" />
        </p>

        {loading ? (
          <p className="text-slate-500">Loading…</p>
        ) : faqs.length === 0 ? (
          <p data-testid="faq-empty" className="text-slate-500">{t('faq.empty')}</p>
        ) : (
          <div className="space-y-3">
            {faqs.map(item => {
              const isOpen = openId === item.id;
              return (
                <div
                  key={item.id}
                  data-testid={`faq-item-${item.id}`}
                  className="rounded-3xl border-2 border-slate-100 bg-white overflow-hidden hover:border-amber-200 transition-all"
                >
                  <button
                    type="button"
                    data-testid={`faq-item-${item.id}-toggle`}
                    onClick={() => setOpenId(isOpen ? null : item.id)}
                    className="w-full flex items-start justify-between gap-4 px-6 py-5 text-left"
                  >
                    <span className="font-bold text-slate-900 text-base sm:text-lg font-['Outfit']">
                      {q(item)}
                    </span>
                    {isOpen
                      ? <ChevronUp className="w-5 h-5 flex-shrink-0 mt-1 text-slate-500" />
                      : <ChevronDown className="w-5 h-5 flex-shrink-0 mt-1 text-slate-500" />}
                  </button>
                  {isOpen && (
                    <div className="px-6 pb-6 text-slate-700 leading-relaxed whitespace-pre-wrap">
                      {a(item)}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};
